import React from "react";

import { Button } from "@mui/material";

import { BaseButtonProps } from "./base/types";

export const OutlinedButton: React.FC<BaseButtonProps> = ({
  text,
  ...props
}) => {
  return (
    <Button variant="outlined" {...props}>
      {text}
    </Button>
  );
};
